import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import {
  handleUnauthorized,
  showConfirmationDialog,
} from "../../utils/apiHelper";

const ChatPaymentListLayer = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Dynamically adjustable items per page
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const navigate = useNavigate();
  // Sorting states
  const [paymentStatus, setpaymentStatus] = useState("");
  const [sortColumn, setSortColumn] = useState("transactionDate");
  const [sortOrder, setSortOrder] = useState("desc");

  const storedPermissions = JSON.parse(
    localStorage.getItem("permissions") || "[]"
  );
  const hostIndividualPermissions = storedPermissions.find(
    (perm) => perm.moduleName === "chatpayment"
  );
  const canView = hostIndividualPermissions?.view || false;
  const userrole = localStorage.getItem("user_role");
  const shouldCheckPermissions = userrole === "support_admin";

  const authToken = localStorage.getItem("authToken");
  useEffect(() => {
    fetchData(currentPage, paymentStatus);
  }, [
    currentPage,
    searchQuery,
    itemsPerPage,
    sortOrder,
    sortColumn,
    paymentStatus,
  ]);
  const fetchData = async (page, paymentStatus) => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/chatTransactionListAdmin?page=${page}&limit=${itemsPerPage}sort=${sortColumn}&order=${sortOrder}&search=${searchQuery}&paymentStatus=${paymentStatus}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setItems(data.transactions || []);
      setTotalItems(data.metadata.totalItems || 0);
      setTotalPages(data.metadata.totalPages || 1);
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to the first page on items per page change
  };

  const handlePaymentStatus = async (event) => {
    const selectpaymentstatus = event.target.value;
    setpaymentStatus(selectpaymentstatus);
    fetchData(currentPage, selectpaymentstatus); // pass it directly
  };
  const getPaginationRange = () => {
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4); // Ensure only 5 items are shown (start + 4)

    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };
  return (
    <div className="card h-100 p-0 radius-12">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className="text-md fw-medium text-secondary-light mb-0">
            Show
          </span>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6"
            style={{
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={itemsPerPage}
            defaultValue="Select Number"
            onChange={handleItemsPerPageChange}
          >
            <option value="10">10 items per page</option>
            <option value="20">20 items per page</option>
            <option value="50">50 items per page</option>
            <option value="100">100 items per page</option>
          </select>
          <form className="navbar-search">
            <input
              type="text"
              className="bg-base h-40-px w-auto"
              name="search"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyUp={(e) => {
                if (e.target.value === "") {
                  setCurrentPage(1);
                }
              }}
            />
            <Icon icon="ion:search-outline" className="icon" />
            {searchQuery && (
              <button
                onClick={() => {
                  setSearchQuery("");
                  setCurrentPage(1);
                }}
                style={{
                  position: "absolute",
                  insetInlineEnd: "1.9375rem",
                  top: "40%",
                  transform: "translateY(-50%)",
                  fontSize: "1.125rem",
                  color: "var(--black)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Icon icon="ic:round-close" />
              </button>
            )}
          </form>
          <select
            className="form-select form-select-sm w-auto ps-12 py-6  h-40-px"
            defaultValue="Select Payment Status"
            style={{
              padding: "2.5625rem 2.875rem 0.5625rem 0.9375rem",
              fontSize: "16px",
              borderRadius: "7px",
              backgroundPositionX: "unset",
              backgroundPosition: "right 0.75rem center",
            }}
            value={paymentStatus}
            onChange={handlePaymentStatus}
          >
            <option value="">Select Payment Status</option>
            <option value="pending">Pending</option>
            <option value="succeeded">Succeeded</option>
            <option value="refund">Failed</option>
          </select>
        </div>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("_id")}
                  style={{ cursor: "pointer" }}
                >
                  Id
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "_id" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "_id" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("amount")}
                  style={{ cursor: "pointer" }}
                >
                  amount($)
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "amount" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "amount" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("renterName")}
                  style={{ cursor: "pointer" }}
                >
                  Renter Name
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "renterName" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "renterName" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("HostName")}
                  style={{ cursor: "pointer" }}
                >
                  Host Name
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "HostName" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "HostName" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("paymentStatus")}
                  style={{ cursor: "pointer" }}
                >
                  Payment Status
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "paymentStatus" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "paymentStatus" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th
                  onClick={() => handleSort("createdAt")}
                  style={{ cursor: "pointer" }}
                >
                  Payment Date{" "}
                  <span className="sort-colume">
                    <Icon
                      icon="mdi:arrow-up"
                      className={`arrow ${
                        sortColumn === "transactionDate" && sortOrder === "asc"
                          ? "active"
                          : ""
                      }`}
                    />
                    <Icon
                      icon="mdi:arrow-down"
                      className={`arrow ${
                        sortColumn === "transactionDate" && sortOrder === "desc"
                          ? "active"
                          : ""
                      }`}
                    />
                  </span>
                </th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    <span className="loader-15"></span>
                  </td>
                </tr>
              ) : items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={item._id}>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {item._id || "N/A"}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {item.amount || "N/A"}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {item.renter.firstName || "N/A"}{" "}
                        {item.renter.lastName || "N/A"}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {item.hostDetails.name || "N/A"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`${
                          item.paymentStatus === "succeeded"
                            ? "text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm"
                            : item.paymentStatus === "failed"
                            ? "text-neutral-600 border border-neutral-400 px-24 py-4 radius-4 fw-medium text-sm"
                            : "text-warning-600 border border-warning-main px-24 py-4 radius-4 fw-medium text-sm"
                        }`}
                      >
                        {item.paymentStatus.charAt(0).toUpperCase() +
                          item.paymentStatus.slice(1)}
                      </span>
                    </td>
                    <td>
                      {(() => {
                        const date = new Date(item.transactionDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = date.getMonth() + 1; // Months are 0-indexed
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()}
                    </td>

                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {(!shouldCheckPermissions || canView) && (
                          <button
                            type="button"
                            onClick={() =>
                              navigate(`/chatpayment/view/${item._id}`)
                            }
                            title="View"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handlePrev}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>
            {getPaginationRange().map((page) => {
              // Return JSX for pagination items
              return (
                <li key={page} className="page-item">
                  <Link
                    className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${
                      currentPage === page
                        ? "bg-primary-600 text-white"
                        : "bg-neutral-200"
                    }`}
                    to="#"
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </Link>
                </li>
              );
            })}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={handleNext}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChatPaymentListLayer;
